/** Where the floating launchers sit, in px: inset from the window corner, launcher size, gap between two of them. */
export const SUPPORT_LAUNCHER = {
  bottom: 16,
  size: 60,
  gap: 16,
}

/** The strip a launcher occupies above the corner, for anything that must not open underneath it. */
export const SUPPORT_LAUNCHER_CLEARANCE = SUPPORT_LAUNCHER.bottom + SUPPORT_LAUNCHER.size + SUPPORT_LAUNCHER.gap

export const SHOW_FLOATING_SUPPORT_LAUNCHER = false
